import React from 'react';
import { useDocumentTitle } from "../../hooks/setDocumentTitle"

function Tips() {
    useDocumentTitle("Free Patterns | Witty Crafts Design");
    return (
        <>
            <h1>Free Patterns</h1>
            <section>
                <div className="row">
                    <div className="card border-0 col-sm-12 col-md-4">
                        <img src="media/pom-pom-border-cover.jpg" className="img-fluid rounded shadow" alt="pom pom border" />
                        <div className="card-body mt-2">
                            <h2 className="card-title">
                                <a href="/free-patterns/pom-pom-border">Pom Pom Border</a>
                            </h2>
                            <p className="card-text">
                               
                            </p>
                        </div>
                    </div>
                    <div className="card border-0 col-sm-12 col-md-4">
                        <img src="media/dolci-beanie.jpg" className="img-fluid rounded shadow" alt="dolci beanie" />
                        <div className="card-body mt-2">
                            <h2 className="card-title">
                                <a href="/free-patterns/dolci-beanie">Dolci Beanie</a>
                            </h2>
                            <p className="card-text">
                                
                            </p>
                            
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default Tips